module.exports = __webpack_public_path__ + "img/backArrow.6f8367c8.svg";